import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';

import { Packages } from '~shared/constants/pricing';

import { FeatureListMap, SummaryFeatureList, SummaryFeatureRuleMap } from '~pricing/transformers/summary/types';
import { formatSummaryFeature } from '~pricing/lib/PackageFeatures';

const PremierAnnualFeatureList: SummaryFeatureList = ['crosstabs', 'click_map_qt'];

// overrides the default individual list when the config flag is set
const DefaultIndividualFeatureList: SummaryFeatureList = [
  'grow_2529_create_limit',
  'grow_2529_unlimited_questions',
  'grow_2529_question_types',
  'response_count',
  'support',
  'analyze_export_enabled',
  'grow_2529_analysis_filter',
  'grow_2529_website_embed',
  'grow_2529_zapier_integrations',
  'skip_logic',
  'statistical_significance',
];

const FormsIndividualFeatureList: SummaryFeatureList = [
  ...DefaultIndividualFeatureList,
  'grow_2529_payment_qt',
  'grow_2529_file_upload',
];

const AdvantageAnnualFeatureList: SummaryFeatureList = [
  'quizzes_pro',
  'grow_2529_survey_branding',
  'analyze_export_spss_enabled',
];

const PremierAndAdvantageAnnualFeatureList = [
  ...FormsIndividualFeatureList,
  ...AdvantageAnnualFeatureList,
  ...PremierAnnualFeatureList,
];

const FormsOverrideRules: SummaryFeatureRuleMap = {
  // Add feature rule overrides below
  grow_2529_create_limit: () => formatSummaryFeature('grow_2529_unlimited_forms'),
  grow_2529_payment_qt: () => formatSummaryFeature('grow_2529_payment_qt'),
};

const StarterRulesOverride: SummaryFeatureRuleMap = {
  support: () => formatSummaryFeature('email_support'),
  statistical_significance: () => formatSummaryFeature('text_analysis'),
};

const Grow2529FeatureListMapTreatment1: FeatureListMap = {
  [EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment1]: {
    [Packages.StarterAnnual]: {
      list: DefaultIndividualFeatureList,
      rules: StarterRulesOverride,
      includesDefaultList: true,
    },
    [Packages.StandardMonthly]: {
      list: DefaultIndividualFeatureList,
      rules: StarterRulesOverride,
      includesDefaultList: true,
    },
    [Packages.AdvantageAnnual]: {
      list: PremierAndAdvantageAnnualFeatureList,
      includesDefaultList: true,
    },
    [Packages.PremierAnnual]: {
      list: PremierAndAdvantageAnnualFeatureList,
      includesDefaultList: true,
    },
    [Packages.FormsAnnual]: {
      list: FormsIndividualFeatureList,
      rules: FormsOverrideRules,
      includesDefaultList: true,
    },
    [Packages.FormsMonthly]: {
      list: FormsIndividualFeatureList,
      rules: FormsOverrideRules,
      includesDefaultList: true,
    },
    [Packages.TeamAdvantage]: {
      list: [],
    },
    [Packages.TeamPremier]: {
      list: [],
    },
    [Packages.Enterprise]: {
      list: [],
    },
  },
};

export default Grow2529FeatureListMapTreatment1;
